export const debounceDelay = 500;
export const shortDebounceDelay = 250;
